<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{application.name}} Users
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-md-5">
        <mat-form-field>
          <mat-select placeholder="Developers" [(ngModel)]="developer" name="developers">
            <mat-option [value]="dev" *ngFor="let dev of developers">
              {{dev.firstName}} {{dev.middleName}} {{dev.lastName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <button mat-raised-button color="accent" (click)="addDeveloper()">
          Add Developer
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <mat-form-field>
          <mat-select placeholder="Manager" [(ngModel)]="manager" name="managers">
            <mat-option *ngFor="let user of managers" [value]="user">
              {{user.firstName}} {{user.middleName}} {{user.lastName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <button mat-raised-button color="accent" (click)="addManager()">
          Add Manager
        </button>
      </div>
    </div>

    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>

    <mat-table [dataSource]="dataSource" matSort>
      <!-- Remove Column -->
      <ng-container matColumnDef="remove">
        <mat-header-cell *matHeaderCellDef> Remove </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button mat-icon-button matTooltip="Remove user" class="license-actions" (click)="removeUser(element)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
        <mat-cell *matCellDef="let user">
          {{user.email}}
        </mat-cell>
      </ng-container>

      <!-- Role Column -->
      <ng-container matColumnDef="role">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Role </mat-header-cell>
        <mat-cell *matCellDef="let user">
          {{user.role}}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

  </mat-card-content>
</mat-card>